import React from 'react';

import inputStyles from './AlmeInput.styles';

import { withStyles, WithStyles } from '@material-ui/core/styles';

import { ButtonProps, TextFieldProps } from '@material-ui/core';
import { AlmeInputConfig } from './AlmeInputConfig';
import AlmeConfigFormControl, { ConfigControlGroups } from '../AlmeConfigFormControl/AlmeConfigFormControl';
import { useIntl } from 'react-intl';
import defaultTranslation from "../../personas/mainPersona/translations/languages.json";

interface AlmeInputConfigToolProps extends WithStyles<typeof inputStyles> {
    namePrefix: string;
    idPrefix: string;
    almeConfig: AlmeInputConfig;
    onConfigChange: (almeConfig: AlmeInputConfig) => void;
}

const AlmeInputConfigTool: React.FC<AlmeInputConfigToolProps> = (props: AlmeInputConfigToolProps) => {
    const intl = useIntl();
    const inputBoxColor = props.almeConfig.input.styles.textField.color;
    const inputBoxVariant = props.almeConfig.input.styles.textField.variant;
    const inputBoxSize = props.almeConfig.input.styles.textField.size;
    const inputBoxPlaceholderText = intl.formatMessage({
        id: "input.inputPlaceHolderText",
        defaultMessage: 'Default input placeholderText',
        description: 'Alme Input placeholder text',
    });
    const inputButtonSubmitButtonText = props.almeConfig.input.submitButtonText;
    const inputButtonColor = props.almeConfig.input.styles.button.color;

    const setInputBoxColor = (event: React.ChangeEvent<HTMLInputElement>) => {
        const newValue = (event.target as HTMLInputElement).value as TextFieldProps['color'];
        const almeConfig = props.almeConfig;
        almeConfig.input.styles.textField.color = newValue;
        props.onConfigChange(almeConfig);
    };

    const setInputBoxVariant = (event: React.ChangeEvent<HTMLInputElement>) => {
        const newValue = (event.target as HTMLInputElement).value as TextFieldProps['variant'];
        const almeConfig = props.almeConfig;
        almeConfig.input.styles.textField.variant = newValue;
        props.onConfigChange(almeConfig);
    };

    const setInputBoxSize = (event: React.ChangeEvent<HTMLInputElement>) => {
        const newValue = (event.target as HTMLInputElement).value as TextFieldProps['size'];
        const almeConfig = props.almeConfig;
        almeConfig.input.styles.textField.size = newValue;
        props.onConfigChange(almeConfig);
    };

    const setInputBoxPlaceholderText = (event: React.ChangeEvent<HTMLInputElement>) => {
        const newValue = (event.target as HTMLInputElement).value;
        const almeConfig = props.almeConfig;
        (defaultTranslation as Record<string, Record<string, string>>)["en-US"]["input.inputPlaceHolderText"] = newValue;
        props.onConfigChange(almeConfig);
    };

    const setInputButtonSubmitButtonText = (event: React.ChangeEvent<HTMLInputElement>) => {
        const newValue = (event.target as HTMLInputElement).value;
        const almeConfig = props.almeConfig;
        almeConfig.input.submitButtonText = newValue;
        props.onConfigChange(almeConfig);
    };

    const setInputButtonColor = (event: React.ChangeEvent<HTMLInputElement>) => {
        const newValue = (event.target as HTMLInputElement).value as ButtonProps['color'];
        const almeConfig = props.almeConfig;
        almeConfig.input.styles.button.color = newValue;
        props.onConfigChange(almeConfig);
    };

    const configControls: ConfigControlGroups[] = [
        {
            name: 'Input Box',
            controlGroups: [
                {
                    label: 'Input Box Color',
                    name: 'inputBoxColor',
                    value: inputBoxColor,
                    changeHandler: setInputBoxColor,
                    radioButtons: ['primary', 'secondary'],
                },
                {
                    label: 'Input Box Variant',
                    name: 'inputBoxVariant',
                    value: inputBoxVariant,
                    changeHandler: setInputBoxVariant,
                    radioButtons: ['outlined', 'filled', 'standard'],
                },
                {
                    label: 'Input Box Size',
                    name: 'inputBoxSize',
                    value: inputBoxSize,
                    changeHandler: setInputBoxSize,
                    radioButtons: ['small', 'medium'],
                },
                {
                    id: `${props.idPrefix}input-box-placeholder-text-config`,
                    label: 'Input Box Placeholder Text',
                    name: `${props.namePrefix}InputBoxPlaceholderText`,
                    value: inputBoxPlaceholderText,
                    changeHandler: setInputBoxPlaceholderText,
                },
            ],
        },
        {
            name: 'Input Button',
            controlGroups: [
                {
                    label: 'Input Button Color',
                    name: 'inputButtonColor',
                    value: inputButtonColor,
                    changeHandler: setInputButtonColor,
                    radioButtons: ['inherit', 'default', 'primary', 'secondary'],
                },
                {
                    id: `${props.idPrefix}input-button-submit-text-config`,
                    label: 'Input Button Submit Button Text',
                    name: `${props.namePrefix}InputButtonSubmitButtonText`,
                    value: inputButtonSubmitButtonText,
                    changeHandler: setInputButtonSubmitButtonText,
                },
            ],
        },
    ];

    return (
        <AlmeConfigFormControl title='Alme Input Config' configControls={configControls} />
    );
};

export default withStyles(inputStyles)(AlmeInputConfigTool);
